<p class="modal-title">Admin: Create Trivia Regular</p>
<div class="body flex flex-col">
  <form
    [formGroup]="triviaRainForm"
    (ngSubmit)="onSubmit()"
    #triviaRainFormRef="ngForm"
  >
    <app-form-field
      class="question"
      [label]="'Question'"
      [formControl]="question"
      [errorType]="'outline'"
      [id]="'question'"
      [placeholder]="'Enter Question...'"
      [error]="
        !question.valid && triviaRainFormRef['submitted']
          ? 'Field is required'
          : ''
      "
    />
    <app-form-field
      class="correct"
      [label]="'Correct Answer'"
      [formControl]="correctAnswer"
      [errorType]="'outline'"
      [id]="'correctAnswer'"
      [placeholder]="'Enter Correct Answer...'"
      [error]="
        !correctAnswer.valid && triviaRainFormRef['submitted']
          ? 'Field is required'
          : ''
      "
    />
    <app-form-field
      class="correct"
      [label]="'Correct Answer 2'"
      [formControl]="correctAnswer2"
      [errorType]="'outline'"
      [id]="'correctAnswer2'"
      [placeholder]="'Enter Correct Answer 2...'"
      [error]="
        !correctAnswer2.valid && triviaRainFormRef['submitted']
          ? 'Field is required'
          : ''
      "
    />
    <app-form-field
      class="correct"
      [label]="'Correct Answer 3'"
      [formControl]="correctAnswer3"
      [errorType]="'outline'"
      [id]="'correctAnswer3'"
      [placeholder]="'Enter Correct Answer 3...'"
      [error]="
        !correctAnswer3.valid && triviaRainFormRef['submitted']
          ? 'Field is required'
          : ''
      "
    />
    <app-form-field
      class="correct"
      [label]="'Correct Answer 4'"
      [formControl]="correctAnswer4"
      [errorType]="'outline'"
      [id]="'correctAnswer4'"
      [placeholder]="'Enter Correct Answer 4...'"
      [error]="
        !correctAnswer4.valid && triviaRainFormRef['submitted']
          ? 'Field is required'
          : ''
      "
    />
    <app-form-field
      class="reward"
      [label]="'Reward'"
      [formControl]="reward"
      [errorType]="'outline'"
      [id]="'reward'"
      [placeholder]="'Enter Reward...'"
      [error]="
        !reward.valid && triviaRainFormRef['submitted']
          ? 'Field is required'
          : ''
      "
    />

    <button class="button button--style-yellow h-32 padding-x-12" type="submit">
      Create Trivia Regular
    </button>
  </form>
</div>
